/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// @material-ui/icons
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import LocalLibraryRoundedIcon from '@material-ui/icons/LocalLibraryRounded';
import CameraRollRoundedIcon from '@material-ui/icons/CameraRollRounded';
// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks() {
  const classes = useStyles();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          href="/about"
          color="transparent"
          target="_self"
          className={classes.navLink}
        >
          <InfoRoundedIcon className={classes.icons} /> Biografie
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/literature"
          color="transparent"
          target="_self"
          className={classes.navLink}
        >
          <LocalLibraryRoundedIcon className={classes.icons}/> Literatura
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/theatre"
          color="transparent"
          target="_self"
          className={classes.navLink}
        >
          <CameraRollRoundedIcon className={classes.icons}/> Teatru
        </Button>
      </ListItem>
    </List>
  );
}
